// extracted by mini-css-extract-plugin
export default {"ClientDetail":"TaskList_ClientDetail__GdBZD","tableResponsive":"TaskList_tableResponsive__Cosgb"};